module.exports = __webpack_public_path__ + "media/short-excited-clapping-screaming.72ae4199.mp3";